(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('EmployeeCustomerSector', EmployeeCustomerSector);

    EmployeeCustomerSector.$inject = ['$resource'];

    function EmployeeCustomerSector ($resource) {
        var resourceUrl =  'api/employee-customer-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
